module.exports = __webpack_public_path__ + "img/add_image_icon.ed4046b7.png";